module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#calendar",
      toString: function () {
        return this.url;
      }
    }